export type RecommendationColor = {
    name: string;
    value: string;
};

export type RecommendationProduct = {
    id: number;
    badge: string;
    title: string;
    description: string;
    image: string;
    colors: RecommendationColor[];
    extraColors: number;
    rating: number;
    reviews: string;
    deal: string;
    dealType:
    | "limited"
    | "special"
    | "seasonal"
    | "premium"
    | "exclusive";
    price: number;
    mrp: number;
    delivery: string;
    deliveryType:
    | "delivery"
    | "fast"
    | "stock";
    category: string;
};

export type RecommendationSectionType =
    | "related"
    | "alsoBought"
    | "relevant"
    | "bestSellers";

const menProducts: RecommendationProduct[] = [
    {
        id: 1001,
        badge: "SALAR CHOICE",
        title: "Premium Solid Casual Shirt",
        description:
            "Pure cotton regular-fit casual shirt crafted for everyday comfort and effortless premium styling.",
        image: "/assets/images/products/men-fas/men-1.png",
        colors: [
            { name: "Navy", value: "#17283e" },
            { name: "Wine", value: "#c72f59" },
            { name: "Green", value: "#4e9d68" },
            { name: "Orange", value: "#ef8d19" },
        ],
        extraColors: 3,
        rating: 4.6,
        reviews: "18.4K",
        deal: "Limited Time Deal",
        dealType: "limited",
        price: 1549,
        mrp: 2899,
        delivery: "Free Delivery Tomorrow",
        deliveryType: "delivery",
        category: "Men Fashion",
    },
    {
        id: 1002,
        badge: "TRENDING NOW",
        title: "Minimal Printed Shirt",
        description:
            "Contemporary printed shirt with breathable premium fabric and a clean modern silhouette.",
        image: "/assets/images/products/men-fas/men-2.png",
        colors: [
            { name: "Black", value: "#222222" },
            { name: "Pink", value: "#dc3764" },
            { name: "Mint", value: "#69ad7e" },
            { name: "Orange", value: "#ef9419" },
        ],
        extraColors: 4,
        rating: 4.4,
        reviews: "12.8K",
        deal: "Flat Price Special",
        dealType: "special",
        price: 1299,
        mrp: 1999,
        delivery: "Fast Delivery Available",
        deliveryType: "fast",
        category: "Men Fashion",
    },
    {
        id: 1003,
        badge: "BEST SELLER",
        title: "Checked Everyday Shirt",
        description:
            "Classic checked cotton shirt with a relaxed fit designed for workdays and weekend styling.",
        image: "/assets/images/products/men-fas/men-3.png",
        colors: [
            { name: "Black", value: "#222222" },
            { name: "Red", value: "#d92f58" },
            { name: "Green", value: "#58a36b" },
            { name: "Orange", value: "#f09319" },
        ],
        extraColors: 3,
        rating: 4.7,
        reviews: "45.5K",
        deal: "Seasonal Price Drop",
        dealType: "seasonal",
        price: 1449,
        mrp: 2499,
        delivery: "Free Delivery Tomorrow",
        deliveryType: "delivery",
        category: "Men Fashion",
    },
    {
        id: 1004,
        badge: "PREMIUM EDIT",
        title: "Resort Printed Shirt",
        description:
            "Premium lightweight resort shirt with statement print, soft texture and relaxed summer styling.",
        image: "/assets/images/products/men-fas/men-4.png",
        colors: [
            { name: "Black", value: "#202020" },
            { name: "Rose", value: "#da3465" },
            { name: "Green", value: "#4eaa6c" },
            { name: "Amber", value: "#ee961b" },
        ],
        extraColors: 5,
        rating: 4.5,
        reviews: "22.1K",
        deal: "Weekend Exclusive",
        dealType: "premium",
        price: 1699,
        mrp: 2799,
        delivery: "Only Few Left in Stock",
        deliveryType: "stock",
        category: "Men Fashion",
    },
    {
        id: 1005,
        badge: "LIMITED EDITION",
        title: "Textured Linen Shirt",
        description:
            "Breathable linen-blend shirt with elevated texture, relaxed styling and premium detailing.",
        image: "/assets/images/products/men-fas/men-5.png",
        colors: [
            { name: "Black", value: "#222222" },
            { name: "Pink", value: "#df3468" },
            { name: "Green", value: "#51a56b" },
            { name: "Orange", value: "#ef9218" },
        ],
        extraColors: 3,
        rating: 4.6,
        reviews: "16.9K",
        deal: "Midnight Deal",
        dealType: "limited",
        price: 1849,
        mrp: 3199,
        delivery: "Free Delivery Tomorrow",
        deliveryType: "delivery",
        category: "Men Fashion",
    },
    {
        id: 1006,
        badge: "SALAR EXCLUSIVE",
        title: "Premium Mandarin Shirt",
        description:
            "Refined mandarin-collar shirt made with soft premium fabric for elevated smart casual occasions.",
        image: "/assets/images/products/men-fas/men-6.png",
        colors: [
            { name: "Black", value: "#242424" },
            { name: "Wine", value: "#d82e61" },
            { name: "Green", value: "#55a66d" },
            { name: "Orange", value: "#ef951c" },
        ],
        extraColors: 6,
        rating: 4.8,
        reviews: "31.2K",
        deal: "Salar Member Deal",
        dealType: "exclusive",
        price: 1749,
        mrp: 2999,
        delivery: "Fast Delivery Available",
        deliveryType: "fast",
        category: "Men Fashion",
    },
];

const womenProducts: RecommendationProduct[] = [
    {
        id: 2001,
        badge: "SALAR CHOICE",
        title: "Floral Midi Dress",
        description:
            "Elegant floral midi dress with a soft silhouette, lightweight fabric and comfortable everyday fit.",
        image: "/assets/images/products/women-fas/women-1.png",
        colors: [
            { name: "Rose", value: "#d94b72" },
            { name: "Black", value: "#222222" },
            { name: "Olive", value: "#6d8350" },
            { name: "Blue", value: "#6f91b8" },
        ],
        extraColors: 4,
        rating: 4.7,
        reviews: "21.8K",
        deal: "Limited Time Deal",
        dealType: "limited",
        price: 1699,
        mrp: 3299,
        delivery: "Free Delivery Tomorrow",
        deliveryType: "delivery",
        category: "Women Fashion",
    },
    {
        id: 2002,
        badge: "TRENDING NOW",
        title: "Premium Casual Top",
        description:
            "Modern casual top with a flattering cut, premium finish and versatile styling for day-to-night looks.",
        image: "/assets/images/products/women-fas/women-5.png",
        colors: [
            { name: "Pink", value: "#df4f7b" },
            { name: "Cream", value: "#eadcc6" },
            { name: "Green", value: "#73a06e" },
            { name: "Black", value: "#202020" },
        ],
        extraColors: 5,
        rating: 4.5,
        reviews: "14.6K",
        deal: "Flat Price Special",
        dealType: "special",
        price: 1199,
        mrp: 1999,
        delivery: "Fast Delivery Available",
        deliveryType: "fast",
        category: "Women Fashion",
    },
    {
        id: 2003,
        badge: "BEST SELLER",
        title: "Classic Blazer Set",
        description:
            "Sophisticated blazer set crafted with structured tailoring, smooth lining and a refined modern finish.",
        image: "/assets/images/products/women-fas/women-6.png",
        colors: [
            { name: "Navy", value: "#26384f" },
            { name: "Beige", value: "#cbb89b" },
            { name: "Wine", value: "#89384c" },
            { name: "Black", value: "#1d1d1d" },
        ],
        extraColors: 3,
        rating: 4.8,
        reviews: "38.4K",
        deal: "Seasonal Price Drop",
        dealType: "seasonal",
        price: 2199,
        mrp: 3899,
        delivery: "Free Delivery Tomorrow",
        deliveryType: "delivery",
        category: "Women Fashion",
    },
    {
        id: 2004,
        badge: "PREMIUM EDIT",
        title: "Embroidered Kurta Set",
        description:
            "Premium embroidered kurta set with elegant detailing, soft fabric and festive-ready styling.",
        image: "/assets/images/products/women-fas/women-4.png",
        colors: [
            { name: "Maroon", value: "#8f3145" },
            { name: "Mustard", value: "#c58b29" },
            { name: "Green", value: "#52765c" },
            { name: "Ivory", value: "#e8dfcc" },
        ],
        extraColors: 6,
        rating: 4.6,
        reviews: "27.3K",
        deal: "Weekend Exclusive",
        dealType: "premium",
        price: 2499,
        mrp: 4499,
        delivery: "Only Few Left in Stock",
        deliveryType: "stock",
        category: "Women Fashion",
    },
    {
        id: 2005,
        badge: "LIMITED EDITION",
        title: "Satin Evening Dress",
        description:
            "Statement satin evening dress with an elegant drape, refined sheen and premium occasion-ready finish.",
        image: "/assets/images/products/women-fas/women-2.png",
        colors: [
            { name: "Wine", value: "#8f2847" },
            { name: "Black", value: "#181818" },
            { name: "Emerald", value: "#2f6658" },
            { name: "Champagne", value: "#d7c19d" },
        ],
        extraColors: 4,
        rating: 4.7,
        reviews: "19.2K",
        deal: "Midnight Deal",
        dealType: "limited",
        price: 2799,
        mrp: 4999,
        delivery: "Free Delivery Tomorrow",
        deliveryType: "delivery",
        category: "Women Fashion",
    },
    {
        id: 2006,
        badge: "SALAR EXCLUSIVE",
        title: "Premium Co-Ord Set",
        description:
            "Contemporary co-ord set with premium tailoring, relaxed comfort and an effortlessly polished look.",
        image: "/assets/images/products/women-fas/women-3.png",
        colors: [
            { name: "Powder Blue", value: "#88a9c4" },
            { name: "Rose", value: "#c9647d" },
            { name: "Black", value: "#202020" },
            { name: "Cream", value: "#e4d9c4" },
        ],
        extraColors: 5,
        rating: 4.9,
        reviews: "34.7K",
        deal: "Salar Member Deal",
        dealType: "exclusive",
        price: 2299,
        mrp: 4199,
        delivery: "Fast Delivery Available",
        deliveryType: "fast",
        category: "Women Fashion",
    },
];

const groceryProducts: RecommendationProduct[] = [
    {
        id: 3001,
        badge: "SALAR CHOICE",
        title: "Vedaka Fenugreek (Methi)",
        description:
            "Premium whole fenugreek seeds with earthy aroma and slight bitterness, ideal for Indian curries and pickles.",
        image: "/assets/images/products/groceries/grocery-1.png",
        colors: [],
        extraColors: 0,
        rating: 4.7,
        reviews: "24.8K",
        deal: "Limited Time Deal",
        dealType: "limited",
        price: 99,
        mrp: 139,
        delivery: "Free Delivery Tomorrow",
        deliveryType: "delivery",
        category: "Groceries",
    },
    {
        id: 3002,
        badge: "BEST SELLER",
        title: "Tata Tea Gold",
        description:
            "Premium blend of CTC tea with Assam tea leaves, offering rich colour, refreshing aroma and smooth taste.",
        image: "/assets/images/products/groceries/grocery-2.png",
        colors: [],
        extraColors: 0,
        rating: 4.8,
        reviews: "41.2K",
        deal: "Daily Fresh Deal",
        dealType: "special",
        price: 159,
        mrp: 190,
        delivery: "Fast Delivery Available",
        deliveryType: "fast",
        category: "Groceries",
    },
    {
        id: 3003,
        badge: "FRESH PICK",
        title: "Farm Fresh Tomatoes",
        description:
            "Fresh hand-picked tomatoes selected for colour, firmness and everyday cooking quality.",
        image: "/assets/images/products/groceries/grocery-4.png",
        colors: [],
        extraColors: 0,
        rating: 4.5,
        reviews: "18.6K",
        deal: "Fresh Produce Offer",
        dealType: "seasonal",
        price: 24,
        mrp: 39,
        delivery: "Delivery Today Available",
        deliveryType: "fast",
        category: "Groceries",
    },
    {
        id: 3004,
        badge: "VALUE PACK",
        title: "Sundeast Marie Light",
        description:
            "Delicate and crisp biscuits, perfect for pairing with tea or coffee for a light and satisfying snack.",
        image: "/assets/images/products/groceries/grocery-5.png",
        colors: [],
        extraColors: 0,
        rating: 4.6,
        reviews: "29.3K",
        deal: "Price Drop",
        dealType: "premium",
        price: 39,
        mrp: 50,
        delivery: "Free Delivery Tomorrow",
        deliveryType: "delivery",
        category: "Groceries",
    },
    {
        id: 3005,
        badge: "PANTRY ESSENTIAL",
        title: "Organic Clove Powder",
        description:
            "Finely ground organic clove powder with strong aroma, suitable for Indian cooking and baking.",
        image: "/assets/images/products/groceries/grocery-6.png",
        colors: [],
        extraColors: 0,
        rating: 4.7,
        reviews: "16.9K",
        deal: "Weekend Exclusive",
        dealType: "exclusive",
        price: 89,
        mrp: 119,
        delivery: "Only Few Left in Stock",
        deliveryType: "stock",
        category: "Groceries",
    },
    {
        id: 3006,
        badge: "POPULAR PICK",
        title: "Vedaka Walnut Kernels",
        description:
            "Premium whole walnut kernels, selected for freshness, texture and rich taste for snacking and cooking.",
        image: "/assets/images/products/groceries/grocery-3.png",
        colors: [],
        extraColors: 0,
        rating: 4.4,
        reviews: "12.5K",
        deal: "Combo Savings",
        dealType: "special",
        price: 199,
        mrp: 279,
        delivery: "Fast Delivery Available",
        deliveryType: "fast",
        category: "Groceries",
    },
];

const applianceProducts: RecommendationProduct[] = [
    {
        id: 4001,
        badge: "SALAR CHOICE",
        title: "Toaster",
        description:
            "Compact and efficient toaster with adjustable browning control, wide slots and removable crumb tray for easy cleaning.",
        image: "/assets/images/products/appliances/appliances-1.png",
        colors: [],
        extraColors: 0,
        rating: 4.7,
        reviews: "18.9K",
        deal: "Limited Time Deal",
        dealType: "limited",
        price: 1499,
        mrp: 2499,
        delivery: "Free Delivery Tomorrow",
        deliveryType: "delivery",
        category: "Home Appliances",
    },
    {
        id: 4002,
        badge: "BEST SELLER",
        title: "Juice Blender",
        description:
            "Powerful motor, multiple speed settings and easy-to-clean design make blending smoothies, shakes and purees effortless.",
        image: "/assets/images/products/appliances/appliances-2.png",
        colors: [],
        extraColors: 0,
        rating: 4.8,
        reviews: "32.4K",
        deal: "Mega Appliance Deal",
        dealType: "special",
        price: 1799,
        mrp: 2799,
        delivery: "Fast Delivery Available",
        deliveryType: "fast",
        category: "Home Appliances",
    },
    {
        id: 4003,
        badge: "SMART PICK",
        title: "High Performance Mixer Grinder",
        description:
            "Powerful mixer grinder designed for everyday grinding, blending and food preparation with durable stainless jars.",
        image: "/assets/images/products/appliances/appliances-3.png",
        colors: [],
        extraColors: 0,
        rating: 4.6,
        reviews: "24.7K",
        deal: "Kitchen Price Drop",
        dealType: "seasonal",
        price: 2499,
        mrp: 3899,
        delivery: "Free Delivery Tomorrow",
        deliveryType: "delivery",
        category: "Home Appliances",
    },
    {
        id: 4004,
        badge: "PREMIUM EDIT",
        title: "Digital Air Fryer",
        description:
            "Powerful digital air fryer with rapid hot-air circulation, preset cooking modes and easy-clean basket design.",
        image: "/assets/images/products/appliances/appliances-4.png",
        colors: [],
        extraColors: 0,
        rating: 4.7,
        reviews: "41.5K",
        deal: "Healthy Cooking Deal",
        dealType: "premium",
        price: 4999,
        mrp: 7999,
        delivery: "Free Delivery Tomorrow",
        deliveryType: "delivery",
        category: "Home Appliances",
    },
    {
        id: 4005,
        badge: "SALAR EXCLUSIVE",
        title: "Digital Air Fryer",
        description:
            "Premium digital air fryer with rapid heating, touch controls and multiple cooking presets for convenient everyday meals.",
        image: "/assets/images/products/appliances/appliances-5.png",
        colors: [],
        extraColors: 0,
        rating: 4.5,
        reviews: "16.8K",
        deal: "Kitchen Special",
        dealType: "exclusive",
        price: 3999,
        mrp: 5999,
        delivery: "Fast Delivery Available",
        deliveryType: "fast",
        category: "Home Appliances",
    },
    {
        id: 4006,
        badge: "POPULAR PICK",
        title: "Coffee Maker",
        description:
            "Enjoy rich, aromatic coffee at home with an easy-to-use coffee maker featuring precise brewing control and sleek modern design.",
        image: "/assets/images/products/appliances/appliances-6.png",
        colors: [],
        extraColors: 0,
        rating: 4.6,
        reviews: "27.3K",
        deal: "Weekend Deal",
        dealType: "limited",
        price: 1799,
        mrp: 2999,
        delivery: "Only Few Left in Stock",
        deliveryType: "stock",
        category: "Home Appliances",
    },
];

const electronicsProducts: RecommendationProduct[] = [
    {
        id: 5001,
        badge: "SALAR CHOICE",
        title: "Samsung Galaxy S25+",
        description:
            "Premium Galaxy smartphone with a vibrant AMOLED display, powerful performance, advanced cameras and a refined everyday flagship experience.",
        image: "/assets/images/products/electronics/electronics-6.png",
        colors: [
            { name: "Navy", value: "#304a65" },
            { name: "Silver", value: "#b7c0c8" },
            { name: "Mint", value: "#93aa9b" },
        ],
        extraColors: 2,
        rating: 4.7,
        reviews: "21.8K",
        deal: "Limited Time Deal",
        dealType: "limited",
        price: 80999,
        mrp: 99999,
        delivery: "Free Delivery Tomorrow",
        deliveryType: "delivery",
        category: "Electronics",
    },
    {
        id: 5002,
        badge: "PREMIUM PICK",
        title: "Samsung Galaxy S25 Ultra",
        description:
            "Ultra-premium Galaxy flagship with an immersive display, pro-grade camera system, powerful performance and productivity-focused features.",
        image: "/assets/images/products/electronics/electronics-1.png",
        colors: [
            { name: "Titanium", value: "#8d8a83" },
            { name: "Black", value: "#282828" },
            { name: "Silver", value: "#c1c1bd" },
        ],
        extraColors: 3,
        rating: 4.9,
        reviews: "38.6K",
        deal: "Flagship Special",
        dealType: "premium",
        price: 119999,
        mrp: 134999,
        delivery: "Free Priority Delivery",
        deliveryType: "fast",
        category: "Electronics",
    },
    {
        id: 5003,
        badge: "BEST SELLER",
        title: "iPhone 17",
        description:
            "Next-generation iPhone with a refined premium design, fast performance, advanced photography and seamless integration across the Apple ecosystem.",
        image: "/assets/images/products/electronics/electronics-2.png",
        colors: [
            { name: "Black", value: "#242424" },
            { name: "White", value: "#e8e8e8" },
            { name: "Blue", value: "#65829d" },
        ],
        extraColors: 2,
        rating: 4.8,
        reviews: "45.2K",
        deal: "Apple Upgrade Deal",
        dealType: "special",
        price: 82900,
        mrp: 89900,
        delivery: "Free Delivery Tomorrow",
        deliveryType: "delivery",
        category: "Electronics",
    },
    {
        id: 5004,
        badge: "PERFORMANCE PICK",
        title: "OnePlus 15",
        description:
            "Performance-focused flagship with a fluid display, powerful hardware, fast charging and a responsive premium experience built for everyday speed.",
        image: "/assets/images/products/electronics/electronics-3.png",
        colors: [
            { name: "Black", value: "#242424" },
            { name: "Silver", value: "#b9babe" },
            { name: "Green", value: "#67796b" },
        ],
        extraColors: 2,
        rating: 4.7,
        reviews: "29.4K",
        deal: "Performance Price Drop",
        dealType: "seasonal",
        price: 72999,
        mrp: 79999,
        delivery: "Fast Delivery Available",
        deliveryType: "fast",
        category: "Electronics",
    },
    {
        id: 5005,
        badge: "SALAR EXCLUSIVE",
        title: "Apple AirPods Pro",
        description:
            "Premium wireless earbuds with immersive sound, active noise cancellation, comfortable fit and seamless connectivity across Apple devices.",
        image: "/assets/images/products/electronics/electronics-4.png",
        colors: [
            { name: "White", value: "#eeeeee" },
        ],
        extraColors: 0,
        rating: 4.8,
        reviews: "56.7K",
        deal: "Audio Special",
        dealType: "exclusive",
        price: 22900,
        mrp: 24900,
        delivery: "Free Delivery Tomorrow",
        deliveryType: "delivery",
        category: "Electronics",
    },
    {
        id: 5006,
        badge: "POPULAR PICK",
        title: "Vivo V50",
        description:
            "Stylish smartphone with a vibrant display, capable camera system, smooth everyday performance and dependable battery life with fast charging.",
        image: "/assets/images/products/electronics/electronics-5.png",
        colors: [
            { name: "Blue", value: "#7591aa" },
            { name: "Red", value: "#984850" },
            { name: "Black", value: "#292929" },
        ],
        extraColors: 2,
        rating: 4.6,
        reviews: "19.7K",
        deal: "Weekend Deal",
        dealType: "limited",
        price: 34999,
        mrp: 39999,
        delivery: "Only Few Left in Stock",
        deliveryType: "stock",
        category: "Electronics",
    },
];

const normalizeCategory = (
    category?: string
) =>
    (category || "")
        .trim()
        .toLowerCase();

const getBaseProducts = (
    category?: string
): RecommendationProduct[] => {
    const value =
        normalizeCategory(category);

    if (
        value.includes("women") ||
        value.includes("female")
    ) {
        return womenProducts;
    }

    if (
        value.includes("grocer") ||
        value.includes("fresh") ||
        value.includes("food")
    ) {
        return groceryProducts;
    }

    if (
        value.includes("appliance") ||
        value.includes("home & kitchen") ||
        value.includes("home appliance") ||
        value.includes("kitchen appliance")
    ) {
        return applianceProducts;
    }

    if (
        value.includes("electronic") ||
        value.includes("mobile") ||
        value.includes("smartphone") ||
        value.includes("phone")
    ) {
        return electronicsProducts;
    }

    if (
        value.includes("men") ||
        value.includes("male")
    ) {
        return menProducts;
    }

    return menProducts;
};

const rotateProducts = (
    products: RecommendationProduct[],
    offset: number
): RecommendationProduct[] => {
    if (!products.length) {
        return [];
    }

    const safeOffset =
        offset % products.length;

    return [
        ...products.slice(safeOffset),
        ...products.slice(
            0,
            safeOffset
        ),
    ];
};

export const getRecommendationProducts = (
    category?: string,
    section: RecommendationSectionType = "related"
): RecommendationProduct[] => {
    const products =
        getBaseProducts(category);

    if (
        section === "alsoBought"
    ) {
        return rotateProducts(
            products,
            1
        );
    }

    if (
        section === "relevant"
    ) {
        return rotateProducts(
            products,
            2
        );
    }

    if (
        section === "bestSellers"
    ) {
        return [...products].sort(
            (a, b) =>
                b.rating -
                a.rating
        );
    }

    return products;
};

export const getCategoryDisplayName = (
    category?: string
) => {
    const value =
        normalizeCategory(category);

    if (
        value.includes("women")
    ) {
        return "Women's Fashion";
    }

    if (
        value.includes("grocer") ||
        value.includes("fresh")
    ) {
        return "Groceries";
    }

    if (
        value.includes("appliance") ||
        value.includes("home & kitchen")
    ) {
        return "Home Appliances";
    }

    if (
        value.includes("electronic") ||
        value.includes("mobile") ||
        value.includes("smartphone") ||
        value.includes("phone")
    ) {
        return "Electronics & Mobiles";
    }

    return "Men's Fashion";
};